import ClientPortal from '../../../plugins/axios'

export default {
    validateLoginProvider(userLoginCredentials) {
        return ClientPortal.post(`${process.env.VUE_APP_API}/provider/login`,
            userLoginCredentials,
            {
                withCredentials: true
            }
        )
    },
    validateLogin(userLoginCredentials) {
        return ClientPortal.post(
            `${process.env.VUE_APP_API}/login/validateLogin`,
            userLoginCredentials,
            {
                withCredentials: true
            }
        )
    },

    verifyToken() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/login/verifyToken`, {
            withCredentials: true
        })
    },
    userLogout() {
        return ClientPortal.get(`${process.env.VUE_APP_API}/login/logout`, {
            withCredentials: true
        })
    }
}
